import { render, staticRenderFns } from "./PageNotPermission.vue?vue&type=template&id=0b016f62&scoped=true"
import script from "./PageNotPermission.vue?vue&type=script&lang=js"
export * from "./PageNotPermission.vue?vue&type=script&lang=js"
import style0 from "./PageNotPermission.vue?vue&type=style&index=0&id=0b016f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b016f62",
  null
  
)

export default component.exports